var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTragLineStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 96,
    viewBox: "0 0 611 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.265 47.6754C606.757 37.3102 600.169 33.7991 597.568 45.6938C587.203 42.1958 583.691 48.7901 595.586 51.3913C592.094 61.763 598.688 65.2746 601.29 53.3799C611.655 56.8713 615.166 50.2836 603.271 47.6823L603.265 47.6754Z",
    fill: "#FEC106"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-152.323 20.5269C25.3818 -71.7274 410.754 193.028 592.388 53.2601",
    stroke: "white",
    strokeWidth: 1.05133,
    strokeDasharray: "2.1 2.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTragLineStar);
export default __webpack_public_path__ + "static/media/trag-line-star.284344bc7a4ac4c04cd0079d00f853ac.svg";
export { ForwardRef as ReactComponent };